import { ServiceType } from "@prisma/postgresClient";

export default ServiceType;

export const VIDEO_THERAPIES_SERVICE_TYPE = [
  ServiceType.THERAPY,
  ServiceType.HYBRID_CARE,
] as ServiceType[];
